import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { Data2Service } from '../common/data2.service';
import { UuidService } from '../common/uuid.service';
import { Company } from './company.model';

@Component({
	selector: 'app-company',
	templateUrl: './company.component.html',
	styleUrls: ['./company.component.css'],
})
export class CompanyComponent implements OnInit {
	pageTitle: string;
	private itemsBeforeDataLoad = 0;
	loader = false;
	editable: boolean;
	lockEdit: boolean;

	company: Company = {
		id: null,
		name: null,
	};

	constructor(
		private readonly api: Data2Service,
		private readonly uuid: UuidService,
		private readonly route: ActivatedRoute,
		private readonly router: Router,
	) {}

	ngOnInit(): void {
		if (this.route.snapshot.params['id']) {
			// We are in edit mode
			this.editable = true;
			this.lockEdit = true;
			this.company.id = this.route.snapshot.params['id'];
		} else {
			// We are in add mode
			this.editable = false;
			this.pageTitle = 'Dodawanie pojazdu';
			this.company.id = this.uuid.generate();
		}
		this.loader = true;
		this.loadData();
	}

	private loadData(): void {
		if (!this.editable) {
			return;
		}
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.api.get('/company/' + this.company.id + '/', (result, error) => {
			this.company = result.data;
			this.pageTitle = 'Edycja: ' + this.company.name;
			this.loader = false;
		});
	}

	editToggle(): void {
		this.lockEdit = !this.lockEdit;
	}

	submit() {
		this.lockEdit = true;
		if (this.editable) {
			this.api.put('/company/' + this.company.id + '/', this.company, (result, error) => {
				this.afterSend(result, error);
			});
		} else {
			this.api.post('/company/', this.company, (result, error) => {
				this.afterSend(result, error);
			});
		}
	}

	private afterSend(result, error) {
		if (error) {
			alert('error - check console');
			return;
		}
		this.router.navigate(['company']);
	}
}
